import { render, staticRenderFns } from "./CustomerFields.vue?vue&type=template&id=8ed489f6&scoped=true"
import script from "./CustomerFields.vue?vue&type=script&lang=js"
export * from "./CustomerFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed489f6",
  null
  
)

export default component.exports